<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Yf12b5/tc-custom/9780814727959.jpg?1718106104240" alt="This image is the cover for the book Gentlemen and the Roughs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gentlemen and the Roughs
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“A seminal work” on class divisions within the Union Army—“One of</b><b> the best examples of . . . scholarship on the social history of Civil War soldiers” (<i>The Journal of Southern History</i>).</b></p><p> During the Civil War, the Union army appeared cohesive enough to withstand four years of grueling war against the Confederates and to claim victory in 1865. But fractiousness bubbled below the surface of the North’s presumably united front. Internal fissures were rife within the Union army: class divisions, regional antagonisms, ideological differences, and conflicting personalities all distracted the army from quelling the Southern rebellion. </p><p> In this highly original contribution to Civil War and gender history, Lorien Foote reveals that these internal battles were fought against the backdrop of manhood. Clashing ideals of manliness produced myriad conflicts, as when educated, refined, and wealthy officers (“gentlemen”) found themselves commanding a hard-drinking group of fighters (“roughs”)—a dynamic that often resulted in violence and even death.  </p><p> Based on extensive research into previously ignored primary sources, <i>The Gentlemen and the Roughs</i> uncovers holes in our understanding of the men who fought the Civil War and the society that produced them. </p><p><b>Finalist for the 2011 Gilder Lehrman Lincoln Prize</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lorien Foote
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?82661778